import NextHead from 'next/head'
import * as React from 'react'
import { useMetaTranslation } from '@/scopes/common/components/useMetaTranslation'

export function MetaTitle({
  titleTranslationTag,
  titleTranslationValues,
}: {
  titleTranslationTag: string
  titleTranslationValues?: Record<string, string>
}) {
  const pageTitle = useMetaTranslation(titleTranslationTag, titleTranslationValues, 'title')

  return (
    <NextHead>
      <title>{pageTitle}</title>
    </NextHead>
  )
}
